import { IconProps } from './index';

const SlideShow: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}

            <path
                d="M7.02018 8.91675V10.6667H9.93685V11.8334H2.93685V10.6667H5.85352V8.91675H1.77018C1.61547 8.91675 1.4671 8.85529 1.3577 8.74589C1.24831 8.6365 1.18685 8.48812 1.18685 8.33342V1.33341H0.603516V0.166748H12.2702V1.33341H11.6868V8.33342C11.6868 8.48812 11.6254 8.6365 11.516 8.74589C11.4066 8.85529 11.2582 8.91675 11.1035 8.91675H7.02018ZM2.35352 7.75008H10.5202V1.33341H2.35352V7.75008ZM5.27018 2.50008L8.18685 4.54175L5.27018 6.58342V2.50008Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default SlideShow;
